const state = {
	done: false
}

const mutations = {
	done(state) {
		state.done = true
	}
}

export default {
	state,
	mutations,
	namespaced: true
}
